import { render, staticRenderFns } from "./DeclaracaoNormal.vue?vue&type=template&id=26ee3d0e&scoped=true&"
import script from "./DeclaracaoNormal.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoNormal.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoNormal.vue?vue&type=style&index=0&id=26ee3d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ee3d0e",
  null
  
)

export default component.exports